import React, { useState, useEffect } from "react";
import "../../styles/Settings.scss";
import {
  createEducationQualification,
  deleteEducationQualification,
  getAllEducationQualifications,
  getEducationQualification,
  updateEducationQualification,
} from "../../services/api";
import Modal from "react-modal";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import ExcelJS from "exceljs";

Modal.setAppElement("#root");

const ITEMS_PER_PAGE = 10;

function EducationQualification() {
  const [qualifications, setQualifications] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editQualification, setEditQualification] = useState(null);

  const [form, setForm] = useState({
    qualification_level: "",
    degree: "",
  });

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [editLoading, setEditLoading] = useState(false);

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();

    const worksheet = workbook.addWorksheet(
      "Education Qualifications"
    );

    worksheet.columns = [
      {
        header: "Qualification Level",
        key: "qualification_level",
      },
      {
        header: "Degree",
        key: "degree",
      },
    ];

    qualifications.forEach((item) => {
      worksheet.addRow({
        qualification_level:
          item.qualification_level || "-",

        degree:
          item.degree || "-",
      });
    });

    const buffer =
      await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url =
      URL.createObjectURL(blob);

    const a =
      document.createElement("a");

    a.href = url;

    a.download =
      "education_qualifications.xlsx";

    a.click();

    URL.revokeObjectURL(url);
  };

  const handlePageChange = (
    newPage
  ) => {
    if (
      newPage < 1 ||
      newPage > pageCount
    )
      return;

    setPage(newPage);
  };

  React.useEffect(() => {
    setPage(1);
  }, [search, qualifications.length]);

  const filteredQualifications =
    qualifications.filter(
      (q) =>
        q.qualification_level
          ?.toLowerCase()
          .includes(
            search.toLowerCase()
          ) ||
        q.degree
          ?.toLowerCase()
          .includes(
            search.toLowerCase()
          )
    );

  const pageCount = Math.ceil(
    filteredQualifications.length /
      ITEMS_PER_PAGE
  );

  const paginatedQualifications =
    filteredQualifications.slice(
      (page - 1) *
        ITEMS_PER_PAGE,
      page * ITEMS_PER_PAGE
    );

  const openCreate = () => {
    setEditQualification(null);

    setForm({
      qualification_level: "",
      degree: "",
    });

    setError("");

    setModalOpen(true);
  };

  const openEdit = async (
    qualification
  ) => {
    await fetchQualificationDetails(
      qualification.id
    );
  };

  const closeModal = () =>
    setModalOpen(false);

  const fetchQualifications =
    async () => {
      setLoading(true);
      setError("");

      try {
        const res =
          await getAllEducationQualifications();

        if (
          res &&
          res.status === "S" &&
          Array.isArray(
            res.result_info
          )
        ) {
          setQualifications(
            res.result_info
          );
        } else {
          setError(
            res?.error_info ||
              "Failed to fetch qualifications"
          );

          setQualifications([]);
        }
      } catch (err) {
        setError(
          "Failed to fetch qualifications. Please try again."
        );

        setQualifications([]);
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
    fetchQualifications();
  }, []);

  const fetchQualificationDetails =
    async (id) => {
      setEditLoading(true);

      setError("");

      try {
        const res =
          await getEducationQualification(
            id
          );

        if (
          res &&
          res.status === "S" &&
          res.result_info
        ) {
          const qualification =
            res.result_info;

          setForm({
            qualification_level:
              qualification.qualification_level ||
              "",

            degree:
              qualification.degree ||
              "",
          });

          setEditQualification(
            qualification
          );

          setModalOpen(true);
        } else {
          setError(
            res?.error_info ||
              "Failed to fetch qualification details"
          );

          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              res?.error_info ||
              "Failed to fetch qualification details",
          });
        }
      } catch (err) {
        setError(
          "Failed to fetch qualification details. Please try again."
        );

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            "Failed to fetch qualification details. Please try again.",
        });
      } finally {
        setEditLoading(false);
      }
    };
   const handleSave = async () => {
    if (!form.qualification_level) {
      Swal.fire({
        text: "Please select qualification level!",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
      return;
    }

    if (!form.degree) {
      Swal.fire({
        text: "Please provide degree!",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
      return;
    }

    if (form.degree.length > 255) {
      Swal.fire({
        text: "Degree should be less than 255 characters",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
      return;
    }

    setError("");


    // const payload = {
    //   qualification_level:
    //     form.qualification_level.trim(),

    //   degree:
    //     form.degree.trim(),
    // };


const cleanedQualificationLevel =
  form.qualification_level.trim();

const cleanedDegree =
  form.degree.trim();


// Duplicate check (case insensitive)
const normalizeText = (value) => {
  return value
    ?.toLowerCase()
    .replace(/\s+/g, "")   // remove all spaces
    .replace(/[.\-_/()]/g, ""); // remove special chars
};


const isDuplicate = qualifications.some((item) => {

  if (
    editQualification &&
    item.id === editQualification.id
  ) {
    return false;
  }


  return (
    normalizeText(item.qualification_level) ===
      normalizeText(form.qualification_level)

    &&

    normalizeText(item.degree) ===
      normalizeText(form.degree)
  );
});


if (isDuplicate) {

  Swal.fire({
    icon: "warning",
    title: "Qualification already exists!",
    text: "Same qualification already exists.",
    showConfirmButton: false,
    timer: 2000,
  });

  return;
}


const payload = {
  qualification_level:
    cleanedQualificationLevel,

  degree:
    cleanedDegree,
};


    try {
      let response;

      if (editQualification) {
        response =
          await updateEducationQualification(
            payload,
            editQualification.id
          );
      } else {
        response =
          await createEducationQualification(
            payload
          );
      }

      if (response?.status === "S") {
        Swal.fire({
          icon: "success",
          title: editQualification
            ? "Qualification updated successfully!"
            : "Qualification created successfully!",
          showConfirmButton: false,
          timer: 1500,
        });

        setModalOpen(false);

        fetchQualifications();
      } else if (
        response?.result_code === 409
      ) {
        Swal.fire({
          icon: "warning",
          title:
            "Qualification already exists!",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        const errorMsg =
          response?.error_info ||
          `Failed to ${
            editQualification
              ? "update"
              : "create"
          } qualification`;

        setError(errorMsg);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMsg,
        });
      }
    } catch (err) {
      const errorMsg =
        err?.message ||
        `Failed to ${
          editQualification
            ? "update"
            : "create"
        } qualification`;

      setError(errorMsg);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMsg,
      });
    }
  };

  const handleDelete = async (
    id
  ) => {
    const result =
      await Swal.fire({
        title: "Are you sure?",
        text:
          "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor:
          "#3085d6",
        cancelButtonColor:
          "#d33",
        confirmButtonText:
          "Yes, delete it!",
      });

    if (result.isConfirmed) {
      try {
        const res =
          await deleteEducationQualification(
            id
          );

        if (
          res &&
          res.status === "S"
        ) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text:
              "Qualification has been deleted.",
            showConfirmButton: false,
            timer: 1500,
          });

          fetchQualifications();
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              res?.error_info ||
              "Failed to delete qualification.",
          });
        }
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            err?.message ||
            "Failed to delete qualification.",
        });
      }
    }
  };

  function getPageNumbers(
    currentPage,
    totalPages,
    maxPagesToShow = 5
  ) {
    const pages = [];

    const half = Math.floor(
      maxPagesToShow / 2
    );

    let start = Math.max(
      currentPage - half,
      1
    );

    let end =
      start +
      maxPagesToShow -
      1;

    if (end > totalPages) {
      end = totalPages;

      start = Math.max(
        end -
          maxPagesToShow +
          1,
        1
      );
    }

    for (
      let i = start;
      i <= end;
      i++
    ) {
      pages.push(i);
    }

    return pages;
  }   
    return (
    <div className="settings-page">
      <div className="settings-header-row">
        <div className="settings-title-group">
          <h1>Education Qualification</h1>
        </div>

        <button
          className="export-btn"
          onClick={handleExport}
        >
          Export
        </button>
      </div>

      <div className="settings-table-controls">
        <input
          className="settings-search"
          placeholder="Search Qualification"
          value={search}
          onChange={(e) =>
            setSearch(e.target.value)
          }
        />

        <button
          className="create-btn"
          onClick={openCreate}
        >
          Create Qualification
        </button>
      </div>

      <div className="settings-table-wrapper">
        {loading ? (
          <div
            style={{
              textAlign: "center",
              padding: "20px",
            }}
          >
            Loading qualifications...
          </div>
        ) : (
          <table className="settings-table">
            <thead>
              <tr>
                <th>
                  Qualification Level
                </th>
                <th>Degree</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {paginatedQualifications.length ===
              0 ? (
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {qualifications.length ===
                    0
                      ? "No qualifications found"
                      : "No qualifications match your search"}
                  </td>
                </tr>
              ) : (
                paginatedQualifications.map(
                  (
                    qualification
                  ) => (
                    <tr
                      key={
                        qualification.id
                      }
                    >
                      <td
                        title={
                          qualification.qualification_level
                        }
                      >
                        {
                          qualification.qualification_level
                        }
                      </td>

                      <td
                        title={
                          qualification.degree
                        }
                      >
                        {
                          qualification.degree
                        }
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <button
                            className="icon-btn edit-btn"
                            title="Edit"
                            onClick={() =>
                              openEdit(
                                qualification
                              )
                            }
                            disabled={
                              editLoading
                            }
                          >
                            {editLoading &&
                            editQualification?.id ===
                              qualification.id ? (
                              <span
                                style={{
                                  fontSize:
                                    "12px",
                                }}
                              >
                                ...
                              </span>
                            ) : (
                              <FaEdit
                                size={18}
                              />
                            )}
                          </button>

                          <button
                            className="icon-btn delete-btn"
                            title="Delete"
                            onClick={() =>
                              handleDelete(
                                qualification.id
                              )
                            }
                          >
                            <FaTrash
                              size={18}
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                )
              )}
            </tbody>
          </table>
        )}
      </div>

      {pageCount > 1 && (
        <div className="settings-pagination">
          <button
            className="pagination-btn"
            onClick={() =>
              handlePageChange(
                page - 1
              )
            }
            disabled={page === 1}
          >
            &lt;
          </button>

          {getPageNumbers(
            page,
            pageCount,
            5
          ).map((pageNum) => (
            <button
              key={pageNum}
              className={
                "pagination-btn" +
                (page === pageNum
                  ? " active"
                  : "")
              }
              onClick={() =>
                handlePageChange(
                  pageNum
                )
              }
            >
              {pageNum}
            </button>
          ))}

          <button
            className="pagination-btn"
            onClick={() =>
              handlePageChange(
                page + 1
              )
            }
            disabled={
              page === pageCount
            }
          >
            &gt;
          </button>
        </div>
      )}

      <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        className="settings-modal"
        overlayClassName="settings-modal-overlay"
      >
        <h2>
          {editQualification
            ? "Edit Qualification"
            : "Create Qualification"}
        </h2>

        <div className="modal-field">
          <label>
            Qualification Level *
          </label>

          <select
        styles={{
                control: (base) => ({
                  ...base,
                  minHeight: 38,
                  borderRadius: 6,
                  fontSize: "1rem",
                  background: "#fff",
                  border: "1.5px solid #d1d5db",
                  marginBottom: "1.2rem",
                }),
                menu: (base) => ({ ...base, zIndex: 20 }),
              }}
            value={
              form.qualification_level
            }
            // placeholder = "select qualification level"
            onChange={(e) =>
              setForm((f) => ({
                ...f,
                qualification_level:
                  e.target.value,
              }))
            }
          >
            <option value="">
              Select Qualification

              Level
            </option>

            <option value="Bachelors">
              Bachelors
            </option>

            <option value="Masters">
              Masters
            </option>

            <option value="Others">
              Others
            </option>
          </select>
        </div>

        <div className="modal-field">
          <label>Degree *</label>

          <input
            value={form.degree}
            onChange={(e) =>
              setForm((f) => ({
                ...f,
                degree:
                  e.target.value,
              }))
            }
            placeholder="Enter Degree"
            autoComplete="off"
          />
        </div>

        {error && (
          <div
            style={{
              color: "#e53e3e",
              marginBottom: 10,
              fontWeight: 500,
            }}
          >
            {error}
          </div>
        )}

        <div className="modal-actions">
          <button
            className="save-btn"
            onClick={handleSave}
          >
            {editQualification
              ? "Update"
              : "Create"}
          </button>

          <button
            className="cancel-btn"
            onClick={closeModal}
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
}
export default EducationQualification;